module.exports = __webpack_public_path__ + "img/share_bg.9410d610.jpg";